import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-alert-card',
  templateUrl: './alert-card.component.html',
  styleUrls: ['./alert-card.component.css']
})
export class AlertCardComponent implements OnInit {
  @Input() size: any;
  @Input() showtext: any;
  @Input() data: any = {}
  @Input() sideButton: boolean
  @Input() addedBy: boolean;
  @Input() others: boolean;
  @Input() title: string;
  @Input() route: string;
  @Input() key: string;



  @Output() getReport = new EventEmitter<string>();
  @Output() getBlock = new EventEmitter<string>();
  @Output() getUnblock = new EventEmitter<string>();
  @Output() getBlockMerchant = new EventEmitter<string>();
  @Output() addStaff = new EventEmitter<any>()
  @Output() alertCreated = new EventEmitter<void>();

  closeResult: string;
  modalOptions: NgbModalOptions;
  showButton = false
  loadMoreArr = []
  loading = false;
  totalItems
  showError = false
  arr = [1, 2, 3, 4, 5]
  modalError = ''
  staticButton
  checkbox = []
  emittedObj = {}
  isDropdown: Boolean = false;
  profilePicture = environment.profileImage;
  allAlerts: [] = [];
  constructor(private authService: AuthservicesService, private router: Router, private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  createAlert() {
    this.authService.createAlerts(this.data).subscribe(
      (res) => {
        this.alertCreated.emit();
      },
      (error) => {
        console.error("Create error:", error);
      }
    );
  }

  open(content) {
    this.addstaff(0);
    this.checkbox = [];
    this.showError = false

    this.modalService.open(content, { scrollable: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  renderImage(img) {
    let image
    if (img == null || img == undefined) {
      image = this.authService.spilturl("")
    } else {
      image = this.authService.spilturl(img)
    }
    return image
  }

  getBlockId(e) {
    this.getBlock.emit(e)

  }


  getUnblockId(e) {
    this.getUnblock.emit(e)
  }



  getReportId(e) {
    this.getReport.emit(e);
  }


  getErrorImage(event) {
    this.authService.geterrorImage(event);
  }

  navigate(e: any) {
    // e.preventDefault();
    if (this.key == 'fellow') {
      this.router.navigate(['/fellowship-directory/fellowship-details', this.data.id])
    }
  }


  navigateCliam() {
    if (this.data.claimType == 'claim') {
      this.router.navigate([this.route], { state: { value: this.data } })
    }
    else if (this.data.claimType == undefined) {
      this.router.navigate([this.route, this.data.id])

    }
  }

  addstaff(skip) {
    this.showButton = true

    this.authService.addStaff(skip, 2).subscribe((res: any) => {
      this.loading = true
      this.totalItems = res.total
      this.concatArray(res.items, this.totalItems);
    }, error => {
      console.log(error)
    })
  }

  selectItem(e, props) {
    if (this.data.type == 'user' || this.data.parentType == 'followers') {
      this.emittedObj = {
        staffId: props._id,
        name: props.name,
        id: this.data.id
      }
    }
    if (this.checkbox.length < 1 && e.target.checked) {
      this.showError = false
      this.checkbox.push(e.target.value);

    }
    else if (e.target.checked == false) {
      this.showError = true
      this.checkbox.pop();
      this.emittedObj = {}

    }
    else {
      e.target.checked = false;

    }
  }


  concatArray(arr, total) {
    if (arr.length != 0) { this.loadMoreArr = this.loadMoreArr.concat(arr) }
    else if (arr.length == 0) {
      this.showButton = false
    }
    if (this.loadMoreArr.length == total && this.loadMoreArr.length != 0) this.showButton = false
  }


  showMore() {
    const skip = this.loadMoreArr.length
    this.addstaff(skip)
  }


  select() {

    let objectStatus = Object.entries(this.emittedObj).length === 0 && this.emittedObj.constructor === Object
    if (objectStatus) {
      this.showError = true
      this.modalError = "Please select one of them."
    }
    else {
      this.addStaff.emit(this.emittedObj)
    }
  }

  openDropdown(event: any) {
    event.preventDefault();
    if(this.isDropdown == false){
      this.isDropdown = true
    }
    else if(this.isDropdown == true){
      this.isDropdown = false
    }
  }
}
